import { useEffect } from "react";

import { isPosthogSdkEnabled } from "config";
import { closePosthogConversations } from "hooks/usePosthogSupport/openPosthogConversations";
import { isPosthogConversationsPanelOpen } from "hooks/usePosthogSupport/posthogConversationsDom";
import { waitForPosthogConversations } from "hooks/usePosthogSupport/waitForPosthogConversations";

const AUTO_LAUNCHER_SUPPRESS_MS = 500;

const sleep = (ms: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

export const PosthogSupportWidgetGuard = () => {
  useEffect(() => {
    if (!isPosthogSdkEnabled) {
      return;
    }

    let mounted = true;

    const suppressAutoLauncher = async () => {
      const conversations = await waitForPosthogConversations();
      if (!mounted || !conversations) {
        return;
      }

      await sleep(AUTO_LAUNCHER_SUPPRESS_MS);
      if (!mounted) {
        return;
      }

      if (conversations.isVisible() && !isPosthogConversationsPanelOpen()) {
        closePosthogConversations(conversations);
      }
    };

    void suppressAutoLauncher();

    return () => {
      mounted = false;
    };
  }, []);

  return null;
};
